import * as React from "react";
import Section from "../Layout/Section";
import * as styles from "./feature.module.css";
import Button from "../UI/Button";

const SolutionFeature = ({feature}) => {
    if (!feature) {
        return null;
    }

    return (
        <Section>
            <div className={styles.feature}>
                <div className={styles.feature__background}>
                    <svg
                        width="1376"
                        height="711"
                        viewBox="0 0 1376 711"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        preserveAspectRatio="none"
                    >
                        <path
                            d="M0 0H1376L1359.44 544.688L1347.44 543.279L1345.94 584.886L290.595 707.793V673.838L0 711V0Z"
                            fill="#040931"
                        />
                    </svg>
                </div>
                <div className={styles.feature__content}>
                    <div>
                        <h2 className={styles.feature__title}>{feature.title}</h2>
                        <p className={styles.feature__desc}>{feature.description}</p>
                        <ul>
                            {feature.list.map((item) => (
                                <li key={item.id} className={styles.feature__listItem}>
                                    {item.text}
                                </li>
                            ))}
                        </ul>
                        <Button isLink href={feature.buttonLink} variant="primary" className={styles.feature__button}>
                            {feature.buttonText}
                        </Button>
                    </div>
                    <div className={styles.feature__video} dangerouslySetInnerHTML={{__html: feature.videoFrame}} />
                </div>
            </div>
        </Section>
    );
};

export default SolutionFeature;
